module.exports = __webpack_public_path__ + "img/caratula_nuevos_colores.88b97aed.jpg";